module.exports = __webpack_public_path__ + "static/img/partner.8eb4f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner.jpg
// module id = 7bi1
// module chunks = 1